import { render, staticRenderFns } from "./notification-list-item.vue?vue&type=template&id=5daeb7d2&scoped=true&lang=pug"
import script from "./notification-list-item.vue?vue&type=script&lang=js"
export * from "./notification-list-item.vue?vue&type=script&lang=js"
import style0 from "./notification-list-item.vue?vue&type=style&index=0&id=5daeb7d2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5daeb7d2",
  null
  
)

export default component.exports